import React from 'react';
import classNames from 'classnames';

import Icon from '@mdi/react';
import { mdiMinus, mdiPlus } from '@mdi/js';

import './style.scss';

export default ({ className, label, open, onClick, children }) => (
  <div
    className={classNames(className, {
      accordion: true,
    })}
  >
    <button className="accordion__toggle" onClick={onClick}>
      <span className="accordion__toggle__label">{label}</span>
      <Icon path={open ? mdiMinus : mdiPlus} size={1} />
    </button>
    {open && <div className="accordion__body">{children}</div>}
  </div>
);
